import React from 'react'
import Head from 'next/head'
import styled from 'styled-components'
import { LvpMarginWrapper } from './LargeVideoPlayerLayout'

// Note: the entirety of this page - including styles - was copied from `next/error`

const ErrorPage = styled.main`
  color: #000;
  background: #fff;
  font-family: -apple-system, BlinkMacSystemFont, Roboto, 'Segoe UI', 'Fira Sans', Avenir,
    'Helvetica Neue', 'Lucida Grande', sans-serif;
  min-height: 300px;
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

const Header = styled.h1`
  display: inline-block;
  border-right: 1px solid rgba(0, 0, 0, 0.3);
  margin: 0;
  margin-right: 20px;
  padding: 10px 23px 10px 0;
  font-size: 24px;
  font-weight: 500;
  vertical-align: top;
`

const Description = styled.div`
  display: inline-block;
  text-align: left;
  line-height: 49px;
  height: 49px;
  vertical-align: middle;
`

const Text = styled.h2`
  font-size: 14px;
  font-weight: normal;
  line-height: inherit;
  margin: 0;
  padding: 0;
`

const TEST_ID_NOT_FOUND = '404-not-found'

const Error404 = () => (
  <ErrorPage>
    <LvpMarginWrapper>
      <Head>
        <title>404: Page Not Found</title>
      </Head>
      <Header data-test={TEST_ID_NOT_FOUND}>404</Header>
      <Description>
        <Text>This page could not be found.</Text>
      </Description>
    </LvpMarginWrapper>
  </ErrorPage>
)

export default Error404
